import axios from 'axios'

export const fetchRoutes = () => axios({ method: 'get', url: '/api/routes' })
